<form [formGroup]="formGroup">
  <div class="form-row">
    <div class="form-group col-md-12">
      <label for="descrizione">Atto di finanziamento</label>
      <input class="form-control" id="descrizione" formControlName="descrizione" type="text" />
    </div>
  </div>
</form>
